import {PoiCategoryIds} from '../constants/pois';

/**
 * The POI category IDs to show for the location competition
 */
export const poiCategoryIds: PoiCategoryIds[] = [
  PoiCategoryIds.Shop,
  PoiCategoryIds.Supermarket
];
